// Token-authenticated calls for the per-booking attendance management
// page that's linked from the 7pm Daily Schedule digest + 9pm
// Attendance Chase emails. The token in `?t=` IS the auth — there's
// no session JWT involved, so the regular pro API client is bypassed.
//
// Backend: src/Controllers/Booking/ProBookingAttendance.controller.ts
import { api } from './api';

export type AttendanceBooking = {
  id: string;
  reference: string;
  service_name: string | null;
  scheduled_start: string;
  duration_minutes: number;
  client_name: string | null;
  client_email: string | null;
  address: string | null;
  status: string;
  attendance_confirmed_at: string | null;
  attendance_confirmed_via: string | null;
};

export async function listProAttendance(token: string) {
  const res = await api.get('/pro/attendance', { params: { t: token } });
  return res.data as {
    status: boolean;
    scheduled_date: string;
    data: AttendanceBooking[];
  };
}

export async function confirmAllAttendance(token: string) {
  const res = await api.post(
    '/pro/attendance/confirm-all',
    {},
    { params: { t: token } },
  );
  return res.data as { status: boolean; confirmed_count: number };
}

export async function confirmOneAttendance(bookingId: string, token: string) {
  const res = await api.post(
    `/pro/attendance/${encodeURIComponent(bookingId)}/confirm`,
    {},
    { params: { t: token } },
  );
  return res.data as { status: boolean; already_confirmed: boolean };
}

export async function cancelOneAttendance(
  bookingId: string,
  token: string,
  reason?: string,
) {
  const res = await api.post(
    `/pro/attendance/${encodeURIComponent(bookingId)}/cancel`,
    { reason: reason ?? null },
    { params: { t: token } },
  );
  return res.data as { status: boolean; message?: string };
}
